(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-builder"] && !Shopify.designMode) return;
  try {
    class BundleBuilderComponent extends HTMLElement {
    /** @type {{currencyCode:string,tiers:Array,flavors:Array,sellingPlans:Array}} */
    #db;
    /** @type {object} Block settings from Liquid */
    #settings;
    /** @type {Map<string, object>} flavor variant GID → flavor data */
    #variantMap;
    /** @type {Map<string, string>} productHandle → badge text */
    #badges = new Map();
    /** @type {Map<string, string>} productHandle → flavor description (custom.flavor metafield) */
    #flavorDescs = new Map();
    /** @type {{ bundleId: string, tier: number, selections: Map, sellingPlanId: string|null, adding: boolean }} */
    #state;
    /** @type {AbortController} */
    #controller;
    /** @type {Intl.NumberFormat} */
    #currencyFmt;
    /** @type {Intl.NumberFormat} */
    #currencyFmtInt;
    /** @type {ResizeObserver|null} Suit la taille des cadres visuels des paliers */
    #tierMediaObserver = null;

    connectedCallback() {
      try {
        this.#readInlineData();
      } catch (err) {
        console.error('[bundle-builder] Init failed:', err);
        this.#renderError(err);
        return;
      }

      this.#buildVariantMap();

      const sizes = this.#tierSizes();
      this.#state = {
        bundleId: this.#generateId(),
        tier: sizes[Math.floor(sizes.length / 2)],
        selections: new Map(),
        sellingPlanId: null,
        purchaseType: 'subscription',
        adding: false,
      };

      this.#applyTheme();
      this.#restore();
      this.#reveal();
      this.#renderTiers();
      this.#renderFlavors();
      this.#renderSellingPlan();
      this.#updateGifts();
      this.#renderDelivery();
      this.#recompute();
      this.#bind();

      this.dispatchEvent(new CustomEvent('bundle:viewed', {
        bubbles: true,
        detail: { bundleId: this.#state.bundleId, tier: this.#state.tier },
      }));

      this.#fetchProductMetafields().then(() => {
        if (this.#badges.size || this.#flavorDescs.size) this.#renderFlavors();
      });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#tierMediaObserver?.disconnect();
      this.#tierMediaObserver = null;
    }

    /* ------------------------------------------------------------------ */
    /*  Setup                                                              */
    /* ------------------------------------------------------------------ */

    #readInlineData() {
      const settingsEl = this.querySelector('[data-bundle-settings]');
      if (!settingsEl) throw new Error('Settings script tag not found in DOM');
      this.#settings = JSON.parse(settingsEl.textContent);

      const dbEl = this.querySelector('[data-bundle-database]');
      if (!dbEl) throw new Error('Database script tag not found in DOM');
      const raw = JSON.parse(dbEl.textContent);

      if (typeof this.#settings.productBadges === 'string') {
        try { this.#settings.productBadges = JSON.parse(this.#settings.productBadges); }
        catch (_) { this.#settings.productBadges = {}; }
      }
      if (typeof this.#settings.productDescriptions === 'string') {
        try { this.#settings.productDescriptions = JSON.parse(this.#settings.productDescriptions); }
        catch (_) { this.#settings.productDescriptions = {}; }
      }

      const tiers = (raw.tiers || [])
        .map(entry => {
          const box = entry.metafield?.ClassicBoxV2 || {};
          const size = Number(box.size) || 0;
          if (!size) return null;
          const allocations = {};
          for (const a of entry.allocations || []) {
            if (a && a.planId != null) allocations[String(a.planId)] = Number(a.price) || 0;
          }
          return {
            variantId: String(entry.variantId),
            gid: box.platformId || `gid://shopify/ProductVariant/${entry.variantId}`,
            size,
            // Prix réel de la variante Shopify (celui encaissé en achat unique).
            // Le prix du snapshot Skio n'est qu'un repli : il est figé.
            priceCents: Number(entry.priceCents) > 0
              ? Number(entry.priceCents)
              : Math.round(Number(box.price || 0) * 100),
            compareAtCents: Number(entry.compareAtCents) || 0,
            imageSrc: entry.variantImage || box.imageSrc || '',
            variantTitle: entry.variantTitle || '',
            allocations,
          };
        })
        .filter(Boolean);

      if (!tiers.length) {
        throw new Error('No tiers found — ensure product variants have a custom.skio_static_box metafield');
      }

      // Flavor list is frozen from tier 0 (merchant spec: same flavors across all tiers).
      const firstBox = raw.tiers[0]?.metafield?.ClassicBoxV2 || {};
      const flavors = (firstBox.selectableProductVariants || []).map(f => ({
        gid: f.platformId,
        variantId: String(f.platformId || '').split('/').pop(),
        productHandle: f.productSlug || '',
        productTitle: f.productTitle || '',
        productVariantTitle: f.productVariantTitle || '',
        productImageSrc: f.imageSrc || '',
        priceCents: Math.round(Number(f.price || 0) * 100),
        outOfStock: !!f.outOfStock,
      }));

      // Le snapshot Skio (métachamp custom.skio_static_box) associe les
      // vignettes de Miel Amandes et Peanut Butter à l'envers. Les deux images
      // sont correctes — seule leur affectation est croisée — donc on les
      // permute au lieu d'injecter de nouvelles URLs, ce qui préserve le
      // cadrage et le fond jaune d'origine.
      // À supprimer dès que le métachamp aura été corrigé côté admin.
      const normalizeTitle = (title) => (title || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      const SWAPPED_IMAGE_PAIRS = [['miel amandes', 'peanut butter']];

      for (const [titleA, titleB] of SWAPPED_IMAGE_PAIRS) {
        const a = flavors.find(f => normalizeTitle(f.productTitle) === titleA);
        const b = flavors.find(f => normalizeTitle(f.productTitle) === titleB);
        if (!a || !b) continue;
        const tmp = a.productImageSrc;
        a.productImageSrc = b.productImageSrc;
        b.productImageSrc = tmp;
      }

      const sellingPlans = (raw.sellingPlanGroups || []).flatMap(group =>
        (group.sellingPlans || []).map(plan => ({
          id: String(plan.id),
          name: plan.name || '',
          groupName: group.name || '',
        }))
      );

      this.#db = {
        currencyCode: raw.currencyCode || 'USD',
        tiers,
        flavors,
        sellingPlans,
      };

      // Formatage aligné sur la boutique : la devise vient de `shop.currency`
      // (transmise dans data-bundle-database) et la locale de l'attribut lang du
      // document. Repli sur en-US / USD si l'une des deux manque.
      const moneyLocale = document.documentElement.lang || 'en-US';
      const moneyCurrency = this.#db.currencyCode || 'USD';
      this.#currencyFmt = new Intl.NumberFormat(moneyLocale, {
        style: 'currency',
        currency: moneyCurrency,
        minimumFractionDigits: 2,
      });
      this.#currencyFmtInt = new Intl.NumberFormat(moneyLocale, {
        style: 'currency',
        currency: moneyCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    #tierSizes() {
      return this.#db.tiers.map(t => t.size);
    }

    #tierBySize(size) {
      return this.#db.tiers.find(t => t.size === size);
    }

    #buildVariantMap() {
      this.#variantMap = new Map();
      for (const flavor of this.#db.flavors) {
        this.#variantMap.set(flavor.gid, flavor);
      }
    }

    async #fetchProductMetafields() {
      const flavors = this.#db.flavors;
      const parser = new DOMParser();
      await Promise.allSettled(
        flavors.map(async (flavor) => {
          if (!flavor.productHandle) return;
          const res = await fetch(`/products/${flavor.productHandle}?sections=bundle-badge-data,bundle-flavor-data`);
          if (!res.ok) return;
          const json = await res.json();
          const badgeHtml = json['bundle-badge-data'] || '';
          const descHtml = json['bundle-flavor-data'] || '';
          const badge = (parser.parseFromString(badgeHtml, 'text/html').body.textContent || '').trim();
          const desc = (parser.parseFromString(descHtml, 'text/html').body.textContent || '').trim();
          if (badge) this.#badges.set(flavor.productHandle, badge);
          if (desc) this.#flavorDescs.set(flavor.productHandle, desc);
        })
      );
    }

    #reveal() {
      const loader = this.querySelector('[data-bb-loading]');
      if (loader) loader.hidden = true;
      for (const el of this.querySelectorAll('[data-bb-step], .bb__tiers, [data-bb-progress], [data-bb-flavor-list], [data-bb-plans], [data-bb-cta]')) {
        el.hidden = false;
      }
    }

    #renderError(err) {
      const loader = this.querySelector('[data-bb-loading]');
      if (loader) {
        loader.className = 'bb__error';
        const prefix = this.#settings?.i18n?.loadError || 'Bundle Builder could not load';
        loader.textContent = `${prefix}: ${err.message}`;
      }
    }

    #applyTheme() {
      // Intentional no-op: colors come from the block's color scheme, not the
      // DynamicBox JSON theme object. This keeps bundle styling consistent with
      // the rest of the theme's design system tokens.
    }

    #generateId() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return `box_${crypto.randomUUID()}`;
      }
      return `box_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }

    /* ------------------------------------------------------------------ */
    /*  Persistence                                                        */
    /* ------------------------------------------------------------------ */

    #persistKey() {
      return `bundle:${this.dataset.bundleRoot}`;
    }

    #restore() {
      if (!this.#settings.persist) return;
      try {
        const raw = localStorage.getItem(this.#persistKey());
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (Date.now() - saved.t > 24 * 3600 * 1000) {
          localStorage.removeItem(this.#persistKey());
          return;
        }
        if (this.#tierSizes().includes(saved.tier)) {
          this.#state.tier = saved.tier;
        }
        if (Array.isArray(saved.selections)) {
          for (const [id, qty] of saved.selections) {
            if (this.#variantMap.has(id) && qty > 0) {
              this.#state.selections.set(id, qty);
            }
          }
        }
        if (saved.sellingPlanId) {
          this.#state.sellingPlanId = saved.sellingPlanId;
        }
        const total = this.#totalSelected();
        if (total > this.#state.tier) {
          this.#trimOverflow(total - this.#state.tier);
        }
      } catch (_) { /* localStorage unavailable — continue in memory */ }
    }

    #persist() {
      if (!this.#settings.persist) return;
      try {
        localStorage.setItem(this.#persistKey(), JSON.stringify({
          t: Date.now(),
          tier: this.#state.tier,
          selections: [...this.#state.selections],
          sellingPlanId: this.#state.sellingPlanId,
        }));
      } catch (_) { /* quota exceeded — swallow */ }
    }

    /* ------------------------------------------------------------------ */
    /*  Pricing                                                            */
    /* ------------------------------------------------------------------ */

    #formatMoney(cents) {
      // Drop the decimal portion when it's exactly .00 (e.g. $50.00 → $50) but
      // keep it for fractional amounts (e.g. $49.99 stays as-is).
      const fmt = cents % 100 === 0 ? this.#currencyFmtInt : this.#currencyFmt;
      // Colle le symbole au montant (29,99 € → 29,99€) : on ne retire que
      // l'espace situé contre le symbole, jamais le séparateur de milliers.
      const parts = fmt.formatToParts(cents / 100);
      return parts
        .filter((part, i) => {
          if (part.type !== 'literal' || !/^[\s\u00A0\u202F]+$/.test(part.value)) return true;
          return parts[i - 1]?.type !== 'currency' && parts[i + 1]?.type !== 'currency';
        })
        .map(part => part.value)
        .join('');
    }

    #computeTierPricing(size) {
      const tier = this.#tierBySize(size);
      if (!tier) return { compareCents: 0, finalCents: 0, perItemCents: 0 };

      // En abonnement, le prix facturé est l'allocation du plan, pas le prix
      // de la variante : le CTA doit afficher ce que le client paiera.
      const planId = this.#planIdForTier(tier);
      const onceCents = this.#onetimeCents(tier);
      const isOnce = this.#state.purchaseType === 'onetime';
      const finalCents = isOnce ? onceCents : this.#subscriptionCents(tier, planId);
      // Achat unique : on barre le compare_at du produit (identique au panier).
      // Abonnement : on barre le prix d'achat unique affiché.
      const compareCents = isOnce
        ? (tier.compareAtCents > onceCents ? tier.compareAtCents : 0)
        : onceCents;

      const portionsPerBox = Math.max(1, Number(this.#settings.tierPortionsPerBox) || 1);
      const totalPortions = size * portionsPerBox;

      return {
        compareCents,
        finalCents,
        perItemCents: totalPortions > 0 ? Math.round(finalCents / totalPortions) : 0,
      };
    }

    #computeSelectionPricing() {
      // Bundle is a single line item — the tier price is the total regardless of flavor mix.
      return this.#computeTierPricing(this.#state.tier);
    }

    /* ------------------------------------------------------------------ */
    /*  Rendering                                                          */
    /* ------------------------------------------------------------------ */

    /** Split tier badge on em/en dash or pipe for two-line promo (e.g. "BEST DEAL — SAVE 20%"). */
    #tierBadgeMarkup(badge) {
      if (!badge) return '';
      const raw = String(badge).trim();
      const parts = raw.split(/\s*[—–\-|]\s*/).map(s => s.trim()).filter(Boolean);
      if (parts.length >= 2) {
        return `<span class="bb__tier-badge"><span class="bb__tier-badge-primary">${this.#esc(parts[0])}</span><span class="bb__tier-badge-secondary">${this.#esc(parts.slice(1).join(' · '))}</span></span>`;
      }
      return `<span class="bb__tier-badge"><span class="bb__tier-badge-primary">${this.#esc(raw)}</span></span>`;
    }

    #renderTiers() {
      const grid = this.querySelector('[data-bb-tier-grid]');
      if (!grid) return;

      const tiers = this.#db.tiers;

      if (tiers.length === 1) {
        const fieldset = grid.closest('.bb__tiers');
        const stepHeader = fieldset?.previousElementSibling;
        fieldset?.setAttribute('hidden', '');
        if (stepHeader?.classList.contains('bb__step')) stepHeader.setAttribute('hidden', '');
        return;
      }

      // Escalier de la maquette : chaque carte est ~4,5 % plus large que la
      // précédente (228 / 238 / 250 px relevés sur le visuel). La hauteur suit
      // toute seule via l'`aspect-ratio` défini dans la feuille de style.
      const widthStep = 0.045;
      grid.style.gridTemplateColumns = tiers
        .map((_, i) => `${(1 - (tiers.length - 1 - i) * widthStep).toFixed(4)}fr`)
        .join(' ');

      grid.innerHTML = tiers.map((tier, i) => {
        const { compareCents, finalCents, perItemCents } = this.#computeTierPricing(tier.size);
        const checked = tier.size === this.#state.tier;
        const badge = this.#settings.tierBadges[i] || '';
        const tierImage = this.#settings.tierImages?.[i] || tier.imageSrc;
        // Pipe "|" lets the variant title author force a line break in the tier card.
        const title = tier.variantTitle || '';
        const titleHtml = title.split('|').map(part => this.#esc(part.trim())).join('<br>');
        const titleAlt = title.replaceAll('|', ' ');
        const tierSuffix = String(this.#settings.tierPerUnitSuffix ?? 'bowl').trim() || 'bowl';
        const perLabel = `${this.#formatMoney(perItemCents)}/${this.#esc(tierSuffix)}`;
        const compareHtml = compareCents > finalCents
          ? `<span class="bb__tier-price-compare"><s>${this.#formatMoney(compareCents)}</s></span>`
          : '';
        const tierImageHtml = tierImage
          ? `<span class="bb__tier-media"><img class="bb__tier-img" src="${this.#safeUrlAttr(tierImage)}" alt="${this.#esc(titleAlt)}" loading="lazy" width="240" height="160" decoding="async" /><span class="bb__tier-qty" aria-hidden="true">x${tier.size}</span></span>`
          : '';

        return `
          <label class="bb__tier" data-tier="${tier.size}">
            ${this.#tierBadgeMarkup(badge)}
            <span class="bb__tier-stack">
              <span class="bb__tier-title">${titleHtml}</span>
              <span class="bb__tier-price-block">
                <span class="bb__tier-price-current">${this.#formatMoney(finalCents)}</span>
                ${compareHtml}
              </span>
              ${tierImageHtml}
            </span>
            <span class="bb__tier-per">${perLabel}</span>
            <input
              type="radio"
              name="bb-tier-${this.dataset.bundleRoot}"
              value="${tier.size}"
              ${checked ? 'checked' : ''}
              class="bb__sr-only"
            />
          </label>`;
      }).join('');

      this.#syncTierMediaMetrics();
    }

    /**
     * Mesure, pour chaque palier, les dimensions réellement occupées par le
     * visuel dans son cadre (`object-fit: contain`) et les expose en variables
     * CSS `--bb-img-width` / `--bb-img-height` sur le cadre.
     *
     * Sans ça, la pastille « xN » se cale sur le cadre : dès qu'un visuel est
     * plus large que son cadre, il est rejeté vers le bas et la pastille reste
     * en l'air au-dessus des sachets. Les visuels des trois paliers n'ayant pas
     * exactement le même cadrage, la mesure est faite image par image.
     */
    #syncTierMediaMetrics() {
      const images = [...this.querySelectorAll('.bb__tier-media .bb__tier-img')];
      if (!images.length) return;

      const measure = (img) => {
        const media = img.closest('.bb__tier-media');
        if (!media) return;
        const boxW = media.clientWidth;
        const boxH = media.clientHeight;
        const natW = img.naturalWidth;
        const natH = img.naturalHeight;
        if (!boxW || !boxH || !natW || !natH) return;
        // Reproduit le calcul de `object-fit: contain`.
        const scale = Math.min(boxW / natW, boxH / natH);
        media.style.setProperty('--bb-img-width', `${Math.round(natW * scale)}px`);
        media.style.setProperty('--bb-img-height', `${Math.round(natH * scale)}px`);
      };

      for (const img of images) {
        if (img.complete && img.naturalWidth) measure(img);
        else img.addEventListener('load', () => measure(img), { once: true });
      }

      this.#tierMediaObserver?.disconnect();
      if (typeof ResizeObserver !== 'function') return;
      this.#tierMediaObserver = new ResizeObserver(() => images.forEach(measure));
      for (const img of images) {
        const media = img.closest('.bb__tier-media');
        if (media) this.#tierMediaObserver.observe(media);
      }
    }

    #renderFlavors() {
      const list = this.querySelector('[data-bb-flavor-list]');
      if (!list) return;

      const flavors = this.#db.flavors;
      const full = this.#totalSelected() >= this.#state.tier;

      list.innerHTML = flavors.map(flavor => {
        const qty = this.#state.selections.get(flavor.gid) || 0;
        const productId = flavor.variantId;
        const badge = this.#badges.get(flavor.productHandle) || this.#settings.productBadges?.[productId] || '';
        const desc = this.#flavorDescs.get(flavor.productHandle) || this.#settings.productDescriptions?.[productId] || '';
        const soldOut = flavor.outOfStock;

        let actionHtml;
        if (soldOut) {
          actionHtml = `<span class="bb__sold-out" aria-disabled="true">${this.#esc(this.#i18n('soldOut', 'Sold out'))}</span>`;
        } else if (qty > 0) {
          actionHtml = `
            <div class="bb__qty">
              <button type="button" data-bb-dec aria-label="Remove one ${this.#esc(flavor.productTitle)}">−</button>
              <span class="bb__qty-count">${qty}</span>
              <button type="button" data-bb-inc aria-label="Add one more ${this.#esc(flavor.productTitle)}" ${full ? 'disabled' : ''}>+</button>
            </div>`;
        } else {
          actionHtml = `<button type="button" class="bb__add" data-bb-add ${full ? 'disabled' : ''} aria-label="Add ${this.#esc(flavor.productTitle)} to bundle">${this.#esc(this.#i18n('add', 'Add'))}</button>`;
        }

        return `
          <li class="bb__flavor"
            data-variant="${flavor.gid}"
            data-selected="${qty > 0}"
            data-sold-out="${soldOut}"
          >
            <div class="bb__flavor-media">
              <img
                class="bb__flavor-img"
                src="${flavor.productImageSrc || ''}"
                alt="${this.#esc(flavor.productTitle)}"
                loading="lazy"
                width="56"
                height="56"
              />
            </div>
            <div class="bb__flavor-info">
              <div class="bb__flavor-head">
                <span class="bb__flavor-name">${this.#esc(flavor.productTitle.toUpperCase())}</span>
                ${badge ? `<span class="bb__pill">${this.#esc(badge)}</span>` : ''}
              </div>
              ${desc ? `<p class="bb__flavor-desc">${this.#esc(desc)}</p>` : ''}
            </div>
            <div class="bb__flavor-actions">
              ${actionHtml}
            </div>
          </li>`;
      }).join('');
    }

    /** Plan à proposer en priorité : celui dont le nom contient le mot-clé du
        réglage « Fréquence par défaut » (ex. « 28 jours »). Évite de tomber sur
        les plans d'un autre outil d'abonnement attachés au même produit. */
    #preferredPlanId(ids) {
      const keyword = String(this.#settings.step3?.defaultPlanKeyword || this.#settings.defaultPlanKeyword || '').trim().toLowerCase();
      if (!keyword) return null;
      const match = (this.#db.sellingPlans || []).find(
        (p) => (!ids || ids.includes(String(p.id))) && String(p.name || '').toLowerCase().includes(keyword),
      );
      return match ? String(match.id) : null;
    }

    #firstSellingPlanId() {
      return this.#preferredPlanId(null) || this.#db.sellingPlans[0]?.id || null;
    }

    /** Plan d'abonnement réellement disponible pour le palier choisi.
        Shopify refuse `selling_plan` si la variante n'a pas d'allocation pour
        ce plan (422 « selling plan is not available ») : on privilégie donc
        toujours une allocation de la variante, et on ne retombe sur le premier
        plan du produit que si la variante n'en expose aucune. */
    #planIdForTier(tier) {
      const ids = tier?.allocations ? Object.keys(tier.allocations) : [];
      if (ids.length) {
        const current = this.#state?.sellingPlanId;
        if (current && ids.includes(String(current))) return String(current);
        return this.#preferredPlanId(ids) || ids[0];
      }
      return this.#state?.sellingPlanId || this.#firstSellingPlanId();
    }

    #renderSellingPlan() {
      const firstId = this.#firstSellingPlanId();
      if (firstId) this.#state.sellingPlanId = firstId;
      if (!firstId) this.#state.purchaseType = 'onetime';
      this.#renderPlans();
    }

    /** Prix abonné : allocation réelle du plan si elle est plus basse, sinon prix du palier. */
    #subscriptionCents(tier, planId) {
      if (!tier) return 0;
      const alloc = planId != null ? tier.allocations?.[String(planId)] : undefined;
      return typeof alloc === 'number' && alloc > 0 && alloc < tier.priceCents ? alloc : tier.priceCents;
    }

    /** Prix d'achat unique affiché. Par défaut le prix barré du produit, comme le
        configurateur du thème Dawn de la boutique ; « price » pour afficher le
        prix réellement facturé par Shopify. */
    #onetimeCents(tier) {
      if (!tier) return 0;
      const compare = tier.compareAtCents > tier.priceCents ? tier.compareAtCents : 0;
      return (this.#settings.step3 || {}).onetimeSource === 'price'
        ? tier.priceCents
        : compare || tier.priceCents;
    }

    /** Remise du palier affiché, arrondie au supérieur (même calcul que le thème Dawn). */
    #planDiscount(tier, planId) {
      const once = this.#onetimeCents(tier);
      const sub = this.#subscriptionCents(tier, planId);
      if (once <= 0 || sub <= 0 || sub >= once) return 0;
      return Math.ceil(((once - sub) / once) * 100);
    }

    #unitLabel(cents, size) {
      const cfg = this.#settings.step3 || {};
      const portions = Math.max(1, Number(this.#settings.tierPortionsPerBox) || 1);
      const total = Math.max(1, size * portions);
      const suffix = String(cfg.unitSuffix || this.#settings.tierPerUnitSuffix || '').trim();
      return `${this.#formatMoney(Math.round(cents / total))}${suffix ? '/' + suffix : ''}`;
    }

    #renderPlans() {
      const host = this.querySelector('[data-bb-plans]');
      if (!host) return;

      const cfg = this.#settings.step3 || {};
      const tier = this.#tierBySize(this.#state.tier);
      if (!tier) return;

      const planId = this.#planIdForTier(tier);
      const hasPlans = !!planId;

      // Sans plan d'abonnement sur le produit, l'étape 3 n'a rien à proposer.
      const step3Header = this.querySelector('[data-bb-step="3"]');
      if (!hasPlans) {
        host.hidden = true;
        if (step3Header) step3Header.hidden = true;
        return;
      }
      host.hidden = false;
      if (step3Header) step3Header.hidden = false;

      const subCents = this.#subscriptionCents(tier, planId);
      const onceCents = this.#onetimeCents(tier);
      // Barré de la carte achat unique : le compare_at du produit, seulement
      // s'il est au-dessus du prix affiché — comme la ligne du panier.
      const onceCompare = tier.compareAtCents > onceCents ? tier.compareAtCents : 0;
      const isSub = this.#state.purchaseType === 'subscription';

      const discount = this.#planDiscount(tier, planId);
      const prefix = String(cfg.discountPrefix || '').trim();
      const discountText = discount ? `${prefix} -${discount}%`.trim() : '';
      // Le gabarit est échappé AVANT insertion : seul le <span> d'accent est du HTML.
      let ribbon = this.#esc(String(cfg.ribbon || ''));
      ribbon = discountText
        ? ribbon.replace('[remise]', `<span class="bb__plan-ribbon-accent">${this.#esc(discountText)}</span>`)
        : ribbon.replace(/\s*:?\s*\[remise\]/, '');
      ribbon = ribbon.replace(/\s+/g, ' ').trim().replace(/[:—–+-]\s*$/, '').trim();

      const benefits = (cfg.benefits || [])
        .filter(Boolean)
        .map(b => `<li class="bb__plan-benefit">${this.#planCheck()}<span>${this.#esc(b)}</span></li>`)
        .join('');

      const plans = this.#db.sellingPlans || [];
      const freqSelect = cfg.showFrequency && plans.length > 1
        ? `<label class="bb__plan-freq">
             <span class="bb__plan-freq-label">${this.#esc(cfg.frequencyLabel || '')}</span>
             <select data-bb-freq>
               ${plans.map(p => `<option value="${this.#esc(p.id)}"${String(p.id) === String(planId) ? ' selected' : ''}>${this.#esc(p.name)}</option>`).join('')}
             </select>
           </label>`
        : '';

      const subCard = `
        <div class="bb__plan bb__plan--sub" data-bb-plan="subscription" data-selected="${isSub}">
          ${ribbon ? `<span class="bb__plan-ribbon">${ribbon}</span>` : ''}
          <label class="bb__plan-head">
            <input type="radio" name="bb-plan-${this.#settings.blockId}" value="subscription" ${isSub ? 'checked' : ''}>
            <span class="bb__plan-titles">
              <span class="bb__plan-title">${this.#esc(cfg.subTitle || '')}</span>
              ${cfg.subSubtitle ? `<span class="bb__plan-subtitle">${this.#esc(cfg.subSubtitle)}</span>` : ''}
            </span>
            <span class="bb__plan-prices">
              <span class="bb__plan-price-line">
                <strong class="bb__plan-price">${this.#formatMoney(subCents)}</strong>
                ${onceCents > subCents ? `<s class="bb__plan-compare">${this.#formatMoney(onceCents)}</s>` : ''}
              </span>
              <span class="bb__plan-unit">${this.#unitLabel(subCents, tier.size)}</span>
            </span>
          </label>
          ${benefits ? `<ul class="bb__plan-benefits" role="list">${benefits}</ul>` : ''}
          <div class="bb__plan-gifts" data-bb-plan-gifts></div>
          ${freqSelect}
        </div>`;

      const onceCard = `
        <div class="bb__plan bb__plan--once" data-bb-plan="onetime" data-selected="${!isSub}">
          <label class="bb__plan-head">
            <input type="radio" name="bb-plan-${this.#settings.blockId}" value="onetime" ${!isSub ? 'checked' : ''}>
            <span class="bb__plan-titles">
              <span class="bb__plan-title">${this.#esc(cfg.onceTitle || '')}</span>
            </span>
            <span class="bb__plan-prices">
              <span class="bb__plan-price-line">
                <strong class="bb__plan-price">${this.#formatMoney(onceCents)}</strong>
                ${onceCompare > onceCents ? `<s class="bb__plan-compare">${this.#formatMoney(onceCompare)}</s>` : ''}
              </span>
              <span class="bb__plan-unit">${this.#unitLabel(onceCents, tier.size)}</span>
            </span>
          </label>
        </div>`;

      // Les cadeaux existants sont déplacés dans la carte abonnement plutôt que
      // dupliqués : un seul DOM, un seul état de déverrouillage. On les détache
      // AVANT de réécrire le contenu, sinon un re-rendu les supprimerait.
      const gifts = cfg.giftsInPlan ? this.querySelector('[data-bb-gifts]') : null;
      if (gifts && host.contains(gifts)) gifts.remove();

      host.innerHTML = subCard + onceCard;

      if (gifts) {
        const slot = host.querySelector('[data-bb-plan-gifts]');
        if (slot && !slot.contains(gifts)) slot.appendChild(gifts);
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Date de livraison estimée                                          */
    /* ------------------------------------------------------------------ */

    /** Aujourd'hui + n jours calendaires, décalé si le jour tombé est fermé. */
    #deliveryDate(days, closedDays) {
      const d = new Date();
      d.setHours(12, 0, 0, 0); // midi : immunise contre les décalages d'heure d'été
      d.setDate(d.getDate() + Math.max(0, Number(days) || 0));
      const closed = closedDays === 'none' ? [] : closedDays === 'sat_sun' ? [0, 6] : [0];
      for (let guard = 0; guard < 7 && closed.includes(d.getDay()); guard++) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }

    #renderDelivery() {
      const host = this.querySelector('[data-bb-delivery]');
      const slot = this.querySelector('[data-bb-delivery-text]');
      if (!host || !slot) return;

      const cfg = this.#settings.delivery || {};
      if (!cfg.enabled) return;

      let min = Number(cfg.minDays) || 0;
      let max = Number(cfg.maxDays) || 0;
      if (max < min) [min, max] = [max, min];

      const first = this.#deliveryDate(min, cfg.closedDays);
      const last = this.#deliveryDate(max, cfg.closedDays);
      const locale = document.documentElement.lang || 'fr-FR';
      const fmt = (date, withMonth) => new Intl.DateTimeFormat(
        locale,
        withMonth ? { weekday: 'short', day: 'numeric', month: 'long' } : { weekday: 'short', day: 'numeric' }
      ).format(date);

      const prefix = this.#esc(String(cfg.prefix || '').trim());
      const join = this.#esc(String(cfg.join || '').trim());
      const sameDay = first.toDateString() === last.toDateString();
      // Le mois n'est répété sur la première date que si les deux tombent
      // dans des mois différents (« ven. 30 juin et le mar. 4 juillet »).
      const sameMonth = first.getMonth() === last.getMonth() && first.getFullYear() === last.getFullYear();

      const parts = sameDay
        ? [prefix, `<strong>${this.#esc(fmt(first, true))}</strong>`]
        : [
            prefix,
            `<strong>${this.#esc(fmt(first, !sameMonth))}</strong>`,
            join,
            `<strong>${this.#esc(fmt(last, true))}</strong>`,
          ];

      slot.innerHTML = parts.filter(Boolean).join(' ');
      host.hidden = false;
    }

    #planCheck() {
      return '<svg class="bb__plan-check" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/><path d="M5.6 10.2 8.5 13l5.9-5.9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    /** Bascule abonnement / achat unique : ré-affiche les cartes et le prix du CTA. */
    #setPurchaseType(type) {
      if (type !== 'subscription' && type !== 'onetime') return;
      if (type === 'subscription' && !this.#firstSellingPlanId()) return;
      if (this.#state.purchaseType === type) return;
      this.#state.purchaseType = type;
      // Les cartes de palier affichent le prix réellement facturé : elles
      // doivent suivre la bascule abonnement / achat unique.
      this.#renderTiers();
      this.#renderPlans();
      this.#recompute();
    }

    /** Build the ATC property key for a flavor — omits the "Default Title" variant suffix. */
    #humanPropKey(flavor) {
      const vt = (flavor.productVariantTitle || '').trim();
      return vt && vt !== 'Default Title' ? `${flavor.productTitle} - ${vt}` : flavor.productTitle;
    }

    #updateGifts() {
      for (const gift of this.querySelectorAll('[data-bb-gift]')) {
        const unlockTier = parseInt(gift.dataset.unlockTier, 10) || Infinity;
        gift.dataset.locked = this.#state.tier < unlockTier ? 'true' : 'false';
      }
      this.#updateGiftsProgress();
    }

    /** 0–1 progress between gift unlock tiers (single bar fill). */
    #giftProgressFraction(tier, tiers) {
      const u0 = tiers[0];
      const u1 = tiers[1];
      const u2 = tiers[2];
      const t = tier;
      if (!Number.isFinite(u0)) return 0;
      if (t < u0) return 0;
      if (!Number.isFinite(u1)) return 1;
      if (t < u1) {
        const d = u1 - u0;
        return d > 0 ? 0.5 * (t - u0) / d : 0.5;
      }
      if (!Number.isFinite(u2)) return 0.5;
      if (t < u2) {
        const d = u2 - u1;
        return d > 0 ? 0.5 + 0.5 * (t - u1) / d : 1;
      }
      return 1;
    }

    /** Gifts stepped bar: one track fill + node highlights vs bundle tier. */
    #updateGiftsProgress() {
      const root = this.querySelector('[data-bb-gifts-progress]');
      if (!root) return;

      const gifts = this.#settings.gifts || [];
      const tiers = [0, 1, 2].map(i => {
        const u = gifts[i]?.unlockTier;
        if (u == null || u === '') return Infinity;
        const n = Number(u);
        return Number.isFinite(n) ? n : Infinity;
      });

      const tier = this.#state.tier;
      const p = this.#giftProgressFraction(tier, tiers);
      root.style.setProperty('--bb-gifts-fill', String(p));

      for (let i = 0; i < 3; i++) {
        const node = root.querySelector(`[data-bb-gift-node="${i}"]`);
        if (node) node.dataset.active = tier >= tiers[i] ? 'true' : 'false';
      }
    }

    #recompute() {
      const sel = this.#totalSelected();
      const tier = this.#state.tier;

      const fill = this.querySelector('[data-bb-progress-fill]');
      const currentEl = this.querySelector('[data-bb-progress-current]');
      const totalEl = this.querySelector('[data-bb-progress-total]');
      const progress = this.querySelector('[data-bb-progress]');
      const cta = this.querySelector('[data-bb-cta]');
      const price = this.querySelector('[data-bb-cta-price]');
      const compare = this.querySelector('[data-bb-cta-compare]');

      if (fill) fill.style.width = `${Math.min((sel / tier) * 100, 100)}%`;
      if (currentEl) currentEl.textContent = String(sel);
      if (totalEl) totalEl.textContent = String(tier);
      if (progress) {
        progress.setAttribute('aria-valuemax', String(tier));
        progress.setAttribute('aria-valuenow', String(sel));
      }
      const ctaMain = this.querySelector('[data-bb-cta-main]');
      const ctaIncomplete = this.querySelector('[data-bb-cta-incomplete]');

      if (cta) {
        // Button stays enabled when incomplete — clicking scrolls to the flavor picker.
        cta.disabled = this.#state.adding;

        if (sel < tier) {
          cta.setAttribute('data-bb-cta-state', 'incomplete');
          const need = tier - sel;
          if (ctaIncomplete) {
            const one = this.#i18n('chooseOneMore', 'Select 1 more flavor');
            const many = this.#i18n('chooseMore', 'Select {count} more flavors');
            ctaIncomplete.textContent =
              need === 1 ? one : many.replace('{count}', String(need));
            ctaIncomplete.hidden = false;
          }
          if (ctaMain) ctaMain.hidden = true;
        } else {
          if (this.#state.adding) {
            cta.setAttribute('data-bb-cta-state', 'adding');
          } else {
            cta.removeAttribute('data-bb-cta-state');
          }
          if (ctaIncomplete) ctaIncomplete.hidden = true;
          if (ctaMain) ctaMain.hidden = false;
        }
      }

      // Prix du bouton : recalculé à chaque changement de palier ou de
      // fréquence, et affiché même quand le bundle n'est pas encore complet.
      const pricing = this.#computeTierPricing(tier);
      const pricingWrap = this.querySelector('[data-bb-cta-pricing]');

      if (price) price.textContent = ` — ${this.#formatMoney(pricing.finalCents)}`;
      if (compare) {
        compare.textContent = pricing.compareCents > pricing.finalCents
          ? this.#formatMoney(pricing.compareCents)
          : '';
      }
      // Prix affiché uniquement quand la boîte est complète (4/6/8 saveurs choisies).
      if (pricingWrap) pricingWrap.hidden = sel < tier || !(pricing.finalCents > 0);

      this.#persist();
    }

    /* ------------------------------------------------------------------ */
    /*  Event handling                                                     */
    /* ------------------------------------------------------------------ */

    #bind() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.addEventListener('change', (e) => {
        const target = /** @type {HTMLInputElement} */ (e.target);

        if (target.name?.startsWith('bb-tier-')) {
          this.#setTier(parseInt(target.value));
          return;
        }

        if (target.name?.startsWith('bb-plan-')) {
          this.#setPurchaseType(target.value);
          return;
        }

        if (target.matches?.('[data-bb-freq]')) {
          this.#state.sellingPlanId = target.value || null;
          this.#state.purchaseType = 'subscription';
          this.#renderTiers();
          this.#renderPlans();
          this.#recompute();
          return;
        }

        if (target.name?.startsWith('bb-sp-')) {
          this.#state.sellingPlanId = target.value || null;
          this.#persist();
        }
      }, { signal });

      this.addEventListener('click', (e) => {
        const target = /** @type {HTMLElement} */ (e.target);

        const planCard = target.closest('.bb__plan');
        if (planCard) {
          // Le clic sur le <label> coche déjà la radio ; ailleurs dans la carte,
          // on bascule manuellement sans dupliquer l'évènement `change`.
          if (!target.closest('.bb__plan-head') && !target.closest('[data-bb-freq]')) {
            this.#setPurchaseType(/** @type {HTMLElement} */ (planCard).dataset.bbPlan);
          }
          return;
        }

        const flavor = target.closest('.bb__flavor');
        if (flavor) {
          const id = /** @type {string} */ (/** @type {HTMLElement} */ (flavor).dataset.variant);
          if (target.closest('[data-bb-add]') || target.closest('[data-bb-inc]')) {
            this.#changeQty(id, 1);
          } else if (target.closest('[data-bb-dec]')) {
            this.#changeQty(id, -1);
          }
          return;
        }

        if (target.closest('[data-bb-cta]')) {
          if (this.#state.adding) return;
          if (this.#totalSelected() < this.#state.tier) {
            const step = this.querySelector('[data-bb-step="2"]')
              || this.querySelector('[data-bb-flavor-list]');
            step?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          this.#submit();
        }
      }, { signal });

      this.addEventListener('keydown', (e) => {
        if (e.target instanceof HTMLElement && e.target.closest('.bb__tier') && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          /** @type {HTMLInputElement|null} */
          const input = e.target.closest('.bb__tier')?.querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }, { signal });
    }

    /* ------------------------------------------------------------------ */
    /*  State mutations                                                    */
    /* ------------------------------------------------------------------ */

    #setTier(size) {
      if (!this.#tierSizes().includes(size)) return;
      this.#state.tier = size;

      const total = this.#totalSelected();
      if (total > size) this.#trimOverflow(total - size);

      this.#renderFlavors();
      this.#updateGifts();
      this.#renderPlans();
      this.#recompute();

      this.dispatchEvent(new CustomEvent('bundle:tier-selected', {
        bubbles: true,
        detail: { bundleId: this.#state.bundleId, tier: size },
      }));
    }

    #trimOverflow(excess) {
      let remaining = excess;
      const entries = [...this.#state.selections.entries()].reverse();
      for (const [id, qty] of entries) {
        if (remaining <= 0) break;
        const take = Math.min(qty, remaining);
        const newQty = qty - take;
        if (newQty === 0) {
          this.#state.selections.delete(id);
        } else {
          this.#state.selections.set(id, newQty);
        }
        remaining -= take;
      }
    }

    #changeQty(variantId, delta) {
      const current = this.#state.selections.get(variantId) || 0;
      const next = current + delta;

      if (next < 0) return;
      if (delta > 0 && this.#totalSelected() >= this.#state.tier) return;

      const variant = this.#variantMap.get(variantId);
      if (delta > 0 && variant?.available === false && variant.inventoryPolicy !== 'continue') return;

      if (next === 0) {
        this.#state.selections.delete(variantId);
      } else {
        this.#state.selections.set(variantId, next);
      }

      this.#renderFlavors();
      this.#recompute();

      if (delta > 0) {
        this.dispatchEvent(new CustomEvent('bundle:flavor-added', {
          bubbles: true,
          detail: { bundleId: this.#state.bundleId, variantId, qty: next },
        }));
      }

      if (this.#totalSelected() === this.#state.tier) {
        this.dispatchEvent(new CustomEvent('bundle:completed', {
          bubbles: true,
          detail: { bundleId: this.#state.bundleId, tier: this.#state.tier },
        }));
      }
    }

    #totalSelected() {
      let total = 0;
      for (const qty of this.#state.selections.values()) total += qty;
      return total;
    }

    /* ------------------------------------------------------------------ */
    /*  Cart submission                                                    */
    /* ------------------------------------------------------------------ */

    async #submit() {
      if (this.#totalSelected() !== this.#state.tier || this.#state.adding) return;

      this.#state.adding = true;
      this.#recompute();

      const tier = this.#tierBySize(this.#state.tier);
      if (!tier) {
        this.#state.adding = false;
        this.#recompute();
        return;
      }

      const item = {
        id: parseInt(tier.variantId, 10),
        quantity: 1,
        properties: { _isClassicBoxV2: true },
      };

      const sellingPlanId = this.#planIdForTier(tier);
      if (sellingPlanId && this.#state.purchaseType !== 'onetime') {
        item.selling_plan = parseInt(sellingPlanId, 10);
        // Trace de diagnostic : visible dans la console si l'abonnement
        // n'arrive pas jusqu'à Loop.
        console.debug('[bundle-builder] abonnement', {
          variant: item.id,
          sellingPlan: item.selling_plan,
          allocations: tier.allocations,
        });
      }

      const contentsParts = [];
      const resolvedSelections = [];
      for (const [gid, qty] of this.#state.selections) {
        const flavor = this.#variantMap.get(gid);
        if (!flavor) {
          this.#state.adding = false;
          this.#recompute();
          document.dispatchEvent(new CustomEvent('toast:open', {
            bubbles: true,
            detail: { type: 'error', message: this.#settings.i18n.cartError },
          }));
          console.error('[bundle-builder] Selected flavor could not be resolved:', gid);
          return;
        }
        const label = this.#humanPropKey(flavor);
        contentsParts.push(`${qty}x ${label}`);
        resolvedSelections.push({ gid: flavor.gid, qty, label });
        item.properties[`_pv${flavor.gid}`] = String(qty);
      }

      // Skio normally expands the paid parent into zero-priced child lines in
      // the Shopify order. Keep a public, human-readable copy as well so the
      // warehouse can still see the exact flavors if another selling-plan app
      // handles the checkout and Skio's order expansion does not run.
      if (resolvedSelections.length !== this.#state.selections.size || !contentsParts.length) {
        this.#state.adding = false;
        this.#recompute();
        document.dispatchEvent(new CustomEvent('toast:open', {
          bubbles: true,
          detail: { type: 'error', message: this.#settings.i18n.cartError },
        }));
        return;
      }
      item.properties['Saveurs'] = contentsParts.join(' · ');
      item.properties['Contents'] = contentsParts.join(', ');

      // Achat unique : on ajoute la variante pack elle-même, SANS selling_plan,
      // pour que Shopify encaisse le prix du pack (34,99 / 44,99 / 54,99 €)
      // et non la somme des sachets à l'unité. Les propriétés Skio
      // (_isClassicBoxV2, _pv…) sont retirées pour que Skio ne traite pas la
      // ligne comme une box d'abonnement ; le détail des saveurs reste lisible
      // par l'entrepôt via « Saveurs » / « Contents ».
      // Abonnement : ligne parente Skio inchangée (création + renouvellement).
      const onetimeItem = {
        id: item.id,
        quantity: 1,
        properties: {
          'Pack': `Pack Découverte — ${this.#state.tier} sachets`,
          'Saveurs': item.properties['Saveurs'],
          'Contents': item.properties['Contents'],
          '_bundleId': this.#state.bundleId,
        },
      };
      const items = this.#state.purchaseType === 'onetime' ? [onetimeItem] : [item];

      // Gifts are handled by the auto-gift app installed on the store; the
      // bundle-builder's role is purely visual (progress bar + unlock tiers).

      // Use the localized cart route when available so multi-market storefronts
      // hit the correct endpoint and Shopify's server-side analytics
      // (`product_added_to_cart`) are attributed to the right market/locale.
      const routes = (window.Theme && window.Theme.routes) || {};
      const cartAddUrl = routes.cart_add_url || '/cart/add.js';
      const cartUrl = routes.cart_url || '/cart';

      // Request the cart-drawer section so it can re-render in a single
      // round-trip (matches product-form.js convention for this theme).
      const sectionIds = new Set();
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl?.dataset.sectionId) sectionIds.add(cartDrawerEl.dataset.sectionId);

      const totalQuantity = items.reduce((sum, item) => sum + (item.quantity || 0), 0);

      try {
        const body = { items, sections_url: window.location.pathname };
        if (sectionIds.size) body.sections = Array.from(sectionIds).join(',');

        const res = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        });

        const response = await res.json().catch(() => null);

        // Shopify returns 422 with a `status`/`message` payload on validation
        // errors (sold out, max qty, invalid variant, etc.).
        if (!res.ok || (response && response.status)) {
          const message = (response && response.message) || 'Cart update failed';

          // Theme convention (product-form.js): surface cart errors as a toast.
          document.dispatchEvent(new CustomEvent('toast:open', {
            bubbles: true,
            detail: { type: 'error', message },
          }));

          throw new Error(message);
        }

        // Fetch the authoritative cart so listeners get accurate item_count,
        // currency, and totals — same pattern as product-form.js.
        let cart = null;
        try {
          const cartRes = await fetch(`${cartUrl}.js`);
          if (cartRes.ok) cart = await cartRes.json();
        } catch (_) { /* noop */ }

        // cart-icon stores the absolute total, so derive the new count from
        // its current value plus what we just added (matches product-form.js).
        const cartIcon = document.querySelector('cart-icon');
        const currentItemCount = cartIcon?.getCurrentItemCount?.() ?? 0;
        const newItemCount = (Number.isNaN(currentItemCount) ? 0 : currentItemCount) + totalQuantity;

        // Theme's CartUpdatedEvent — cart-drawer re-renders its section,
        // cart-icon updates the bubble (and auto-opens the drawer when
        // its data-add-to-cart-behavior is set to 'open_cart').
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            resource: cart || {},
            data: {
              source: 'bundle-builder',
              itemCount: newItemCount,
              sections: response && response.sections,
            },
          },
        }));

        // Keep the legacy business event for downstream integrations
        // (e.g. GTM dataLayer, A/B tests) that already listen for it.
        this.dispatchEvent(new CustomEvent('bundle:added-to-cart', {
          bubbles: true,
          detail: {
            bundleId: this.#state.bundleId,
            tier: this.#state.tier,
            itemCount: items.length,
          },
        }));

        try { localStorage.removeItem(this.#persistKey()); } catch (_) { /* noop */ }

        this.#state.selections.clear();
        this.#state.bundleId = this.#generateId();

        // Respect the merchant-configured post-add behavior.
        const behavior = this.#settings.postAddBehavior || 'drawer';
        if (behavior === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        if (behavior === 'redirect') {
          window.location.href = cartUrl;
          return;
        }
        if (behavior === 'drawer') {
          // cart-drawer listens for ThemeEvents.cartOpen ('cart:open').
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        }
        return;
      } catch (err) {
        console.error('[bundle-builder] Cart add failed:', err);
        this.#showToast(this.#i18n('cartError', 'Could not add to cart. Please try again.'));
      } finally {
        this.#state.adding = false;
        this.#renderFlavors();
        this.#recompute();
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Utilities                                                          */
    /* ------------------------------------------------------------------ */

    #showToast(message) {
      const existing = this.querySelector('.bb__toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'bb__toast';
      toast.textContent = message;
      toast.setAttribute('role', 'alert');
      this.appendChild(toast);
      setTimeout(() => toast.remove(), 4000);
    }

    #esc(str) {
      const el = document.createElement('span');
      el.textContent = str;
      return el.innerHTML;
    }

    /** Escape a URL for use in HTML double-quoted attributes. */
    #safeUrlAttr(url) {
      return String(url)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
    }

    #i18n(key, fallback) {
      return this.#settings?.i18n?.[key] || fallback;
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilderComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
